var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaypalPay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.129,
    height: 21.39,
    viewBox: "0 0 18.129 21.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paypal-3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69853",
    "data-name": "Path 69853",
    d: "M5.459,20.963l.371-2.355L5,18.589H1.061L3.8,1.214a.224.224,0,0,1,.223-.19h6.649c2.207,0,3.73.459,4.526,1.366a3.114,3.114,0,0,1,.725,1.359,4.906,4.906,0,0,1,0,1.874l-.009.055v.479l.373.211a2.616,2.616,0,0,1,.755.576,2.68,2.68,0,0,1,.612,1.374,5.811,5.811,0,0,1-.087,1.993,7.019,7.019,0,0,1-.817,2.256,4.641,4.641,0,0,1-1.294,1.418,5.248,5.248,0,0,1-1.742.786,8.688,8.688,0,0,1-2.177.252h-.517a1.556,1.556,0,0,0-1.539,1.313l-.039.212L8.793,20.7l-.03.152a.131.131,0,0,1-.041.089.11.11,0,0,1-.068.025Z",
    transform: "translate(-0.309 -0.298)",
    fill: "#253b80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69854",
    "data-name": "Path 69854",
    d: "M18.139,7.667q-.03.19-.068.39c-.877,4.5-3.876,6.057-7.708,6.057H8.412a.947.947,0,0,0-.936.8l-1,6.334-.283,1.8a.5.5,0,0,0,.493.577h3.46a.833.833,0,0,0,.822-.7L11,22.745l.651-4.134.042-.227a.832.832,0,0,1,.822-.7h.517c3.352,0,5.976-1.361,6.743-5.3A4.512,4.512,0,0,0,19.086,8.4a3.308,3.308,0,0,0-.947-.73Z",
    transform: "translate(-1.802 -2.233)",
    fill: "#179bd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69855",
    "data-name": "Path 69855",
    d: "M17.75,7.022a6.916,6.916,0,0,0-.853-.189,10.833,10.833,0,0,0-1.72-.125H9.967a.831.831,0,0,0-.822.7L8.037,14.431l-.032.2a.947.947,0,0,1,.936-.8h1.951c3.831,0,6.831-1.556,7.708-6.057.026-.133.048-.263.068-.39a4.674,4.674,0,0,0-.721-.3q-.1-.032-.2-.062Z",
    transform: "translate(-2.331 -1.953)",
    fill: "#222d65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69856",
    "data-name": "Path 69856",
    d: "M6.814,5.457a.829.829,0,0,1,.822-.7h5.211a10.834,10.834,0,0,1,1.72.125,6.916,6.916,0,0,1,1.05.25,4.744,4.744,0,0,1,.721.3,4.252,4.252,0,0,0-.9-3.822C14.444.483,12.654,0,10.364,0H3.716a.95.95,0,0,0-.939.8L.007,18.357a.571.571,0,0,0,.564.661h4.1l1.031-6.539Z",
    transform: "translate(0)",
    fill: "#253b80"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalPay);
export default __webpack_public_path__ + "static/media/paypal-pay.8e7c290537467887fd7de90837c5ae7f.svg";
export { ForwardRef as ReactComponent };